<template>
  <div v-if="data" class="review">
    <div class="review__top">
      <span class="review__name" v-if="data.name || data.surname">
        {{ [data.name, data.surname].filter((a) => a).join(" ") }}
      </span>
      <span v-else class="review__name">Аноним</span>
      <ReviewStarsComponent v-if="stars" :mark="data.mark" />
      <time class="review__date" v-if="data.created_at" :datetime="data.created_at | robotDate">
        {{ data.created_at | humanDate }}
      </time>
    </div>
    <div class="review__description">
      <div v-if="data.description" class="review__description-item">
        <div class="review__description-text">
          {{ data.description }}
        </div>
      </div>
      <div v-if="data.pros" class="review__description-item">
        <IconComponent name="add" />
        <div class="review__description-text">
          {{ data.pros }}
        </div>
      </div>
      <div v-if="data.cons" class="review__description-item">
        <IconComponent name="minus" />
        <div class="review__description-text">
          {{ data.cons }}
        </div>
      </div>
    </div>
    <div v-if="$options.filters.iframe_link(data.video_link)" class="review__video">
      <IframeComponent :link="data.video_link | iframe_link" />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import ReviewStarsComponent from "components/reviews/ReviewStarsComponent.vue";
import IframeComponent from "components/IframeComponent.vue";

export default {
  name: "ReviewComponent",
  components: { IconComponent, ReviewStarsComponent, IframeComponent },
  props: {
    data: Object,
    stars: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="stylus">
.review {
  position relative
  display flex
  flex-direction column
  gap 15px
  border: 1px solid var(--main-color-75)
  border-radius: var(--main_radius)
  padding 20px

  &__image {
    absolute left top
    width 48px
    height 48px
    border-radius 50px
    object-fit cover
    object-position center
  }

  &__top {
    display flex
    flex-wrap wrap
    align-items center
    gap 15px
  }

  &__name {
    font-weight: 700;
  }

  &__date {
    font-size: 0.75em
    line-height: 145%;
    color: var(--dark_o5)
    margin-left auto
    +below(560px) {
      width 100%
    }
  }

  &__description {
    display flex
    flex-direction column
    gap 10px
    font-weight: normal;
    font-size: 0.875em;
    line-height: 20px;
    color var(--black)

    &-item {
      display: flex;
      align-items flex-start
      gap 10px
    }
  }

  &__video {
    border-radius: var(--main_radius)
    overflow: hidden

    > .iframe {
      width: 100%
      height: 223px
    }
  }
}
</style>
